/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Title/view.blocks to change it.
import * as fromData from 'Simple/Data'
import DataVaxiomPersonTitleSelect from 'DesignSystem/Data/DataVaxiom/DataVaxiomPerson/DataVaxiomPersonTitleSelect/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Title({
  children,
  viewPath = "/DesignSystem/DataVaxiomEmployeeProfessionalsRelationshipsItem/Edit/Content/Details/Person/Title",
  onChange
  
}) {
let editProfessionalEmployeeProviderEmployeeResourceEmploymentContractPersonTitleValueData = fromData.useDataValue({ viewPath,
context: 'edit_professional',
path: 'employee.provider.employee_resource.employment_contract.person.title',
})
let editProfessionalEmployeeProviderEmployeeResourceEmploymentContractPersonTitleChangeData = fromData.useDataChange({ viewPath,
context: 'edit_professional',
path: 'employee.provider.employee_resource.employment_contract.person.title',
})
  return (<React.Fragment
>
<DataVaxiomPersonTitleSelect
  viewPath={`${viewPath}/DataVaxiomPersonTitleSelect`}
 size="medium"
 data="edit_professional.employee.provider.employee_resource.employment_contract.person.title"
 value={editProfessionalEmployeeProviderEmployeeResourceEmploymentContractPersonTitleValueData}
 onChange={editProfessionalEmployeeProviderEmployeeResourceEmploymentContractPersonTitleChangeData}
/>
{children}
</React.Fragment>)
}